<!--
  邀请有奖-分享
  lovi 2020-07-07
-->
<template>
  <div class="w100 share">
    <div class="slogan">
      <h2>{{ $t("invite.shareH2") }}</h2>
      <h3>{{ $t("invite.shareH3") }}</h3>
      <h4>{{ $t("invite.shareH4") }}</h4>
    </div>
    <div class="reg-info">
      <van-cell-group>
        <van-field
          clearable
          v-model="reginfo.username"
          :error="error.username ? true : false"
          @input="changeUsername"
          :placeholder="$t('common.AccountFormat')"
        />
        <van-field
          clearable
          :right-icon="eye ? 'eye-o' : 'closed-eye'"
          @click-right-icon="eye = !eye"
          :type="eye ? 'text' : 'password'"
          v-model="reginfo.password"
          :error="error.password ? true : false"
          @input="changePassword"
          :placeholder="$t('common.PasswordFormat')"
        />
        <van-field
          class="van-field-phone"
          clearable
          v-model="reginfo.phone"
          type="tel"
          :error="error.phone ? true : false"
          :maxlength="telMax"
          :formatter="_phoneFormat"
          @input="changePhone"
          :placeholder="$t('common.enterMobile')"
        />
        <van-field
          class="van-field-code"
          clearable
          v-model="reginfo.code"
          :error="error.code ? true : false"
          @input="changeCode"
          :placeholder="$t('common.enterVerificationCode')"
        >
          <div slot="button">
            <van-count-down
              v-if="countDownFlag"
              :time="60000"
              :format="$t('common.remaining') + 'ss s'"
              @finish="finished"
            />
            <span v-else @click="sendMobile">
              {{ againFlag ? $t("common.getAgain") : $t("common.getItNow") }}
            </span>
          </div>
        </van-field>
        <van-field
          clearable
          :type="eye ? 'digit' : 'password'"
          v-model="reginfo.payPsd"
          :error="error.payPsd ? true : false"
          @input="changePayPsd"
          :placeholder="$t('common.enterPayPsd')"
        />
        <van-field
          clearable
          :type="eye ? 'digit' : 'password'"
          v-model="reginfo.confirmPayPsd"
          :error="error.confirmPayPsd ? true : false"
          @input="changeConfirmPayPsd"
          :placeholder="$t('common.enterConfirmPsd')"
        />
      </van-cell-group>
      <div class="button-wrap">
        <van-button
          round
          type="primary"
          block
          :loading="btnLoading"
          @click="register"
        >
          {{ $t("common.register") }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as validate from "@/commonJs/validate.js";
export default {
  name: "share",
  meta: {
    power: false,
    service: false
  },
  components: {},
  data() {
    return {
      id: "",
      reginfo: {
        username: "",
        password: "",
        phone: "",
        code: "",
        payPsd: "",
        confirmPayPsd: ""
      },
      error: {
        username: false,
        password: false,
        phone: false,
        code: false,
        payPsd: false,
        confirmPayPsd: false
      },
      eye: false,
      telMax: 13,
      countDownFlag: false, // 倒计时
      againFlag: false, // 重新获取短信验证码
      btnLoading: false
    };
  },
  created() {
    this.id = this.$route.query.id || "";
  },
  mounted() {},
  computed: {},
  methods: {
    changeUsername() {
      // 账号
      this.error.username = validate.validateUserName(this.reginfo.username);
    },
    changePassword() {
      // 验证密码
      this.error.password = validate.validatePsd(this.reginfo.password);
    },
    changePhone(value) {
      // 手机
      console.log("phone", value);
      let firstStr = (value + "").substr(0, 1);
      if (firstStr == "0") {
        //如果第一个字符是0，则输入框最多输入13位
        this.telMax1 = 13;
      } else {
        //否则输入框最多输入12位
        this.telMax1 = 12;
      }
      let phone = value.replace(/\s/g, "");
      this.error.phone = validate.validateMobile(phone);
    },
    changeCode() {
      // 验证码
      this.error.code = validate.validateCode(this.reginfo.code);
    },
    changePayPsd() {
      // 验证支付密码
      this.error.payPsd = validate.validatePayPsd(this.reginfo.payPsd);
    },
    changeConfirmPayPsd() {
      // 验证确认支付密码
      if (this.reginfo.confirmPayPsd != this.reginfo.payPsd) {
        this.error.confirmPayPsd = this.$t("common.twoPsdInconformity");
      } else {
        this.error.confirmPayPsd = false;
      }
    },
    finished() {
      // 倒计时结束
      this.countDownFlag = false;
      this.againFlag = true;
    },
    sendMobile() {
      // 获取手机验证码
      let vm = this;
      if (vm.reginfo.phone == "") {
        vm.$toast(vm.$t("common.enterMobile"));
        return false;
      }
      console.log(vm.error);
      if (vm.error.phone) {
        vm.$toast(vm.error.phone);
        return false;
      }
      let params = {};
      // 号码处理先删除空格转换成数字再补0
      params.phone = "0" + Number(vm.reginfo.phone.replace(/\s/g, ""));
      params.type = 2;
      vm.$post("/app/captcha/sendMobile", params, {
        alert: true,
        loading: true
      }).then(res => {
        console.log("sendMobile", res);
        if (res.code == 0) {
          vm.countDownFlag = true;
        } else {
          vm.$toast(res.msg);
        }
      });
    },
    register() {
      // 注册
      let vm = this;
      if (vm.reginfo.username == "") {
        vm.$toast(vm.$t("common.enterAccount"));
        return false;
      }
      if (vm.reginfo.password == "") {
        vm.$toast(vm.$t("common.enterPassword"));
        return false;
      }
      if (vm.reginfo.phone == "") {
        vm.$toast(vm.$t("common.enterMobile"));
        return false;
      }
      if (vm.reginfo.code == "") {
        vm.$toast(vm.$t("common.enterVerificationCode"));
        return false;
      }
      if (vm.reginfo.payPsd == "") {
        vm.$toast(vm.$t("common.enterPayPsd"));
        return false;
      }
      if (vm.reginfo.confirmPayPsd == "") {
        vm.$toast(vm.$t("common.enterConfirmPsd"));
        return false;
      }
      for (let key in vm.error) {
        if (vm.error[key]) {
          vm.$toast(vm.error[key]);
          return false;
        }
      }
      let params = {};
      params.username = vm.reginfo.username;
      params.password = vm.reginfo.password;
      params.phone = "0" + Number(vm.reginfo.phone.replace(/\s/g, ""));
      params.code = vm.reginfo.code;
      params.pay_password = vm.reginfo.confirmPayPsd;
      params.Invitees_id = vm.id;
      vm.btnLoading = true;
      vm.$post("/app/user/register", params, { alert: true }).then(res => {
        vm.btnLoading = false;
        console.log("register", res);
        if (res.code == 0) {
          vm.$toast(res.msg);
          localStorage.setItem("token", res.data.token);
          vm.$store.dispatch("SET_TOKEN", res.data.token);
          vm.$store.dispatch("GET_USER_INFO");
          vm.$router.push({
            path: "/home"
          });
        } else {
          vm.$toast(res.msg);
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.share {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: 100vh;
  background: url("@{images}personal/invite/bg.png") no-repeat center;
  background-size: cover;
}

.slogan {
  padding: 20px;
  h2,
  h3,
  h4 {
    padding: 8px 0;
    font-size: 24px;
    font-weight: 500;
    font-family: Source Han Sans CN;
    color: #fff;
    line-height: 1.2;
    text-shadow: 0px 5px 8px rgba(28, 35, 129, 1);
  }
}

/deep/.van-cell-group {
  margin: 0 20px;
  background: transparent;
  &::after {
    content: normal;
  }
  .van-cell {
    margin: 10px 0;
    padding: 10px 16px;
    border-radius: 4px;
    &::after {
      content: normal;
    }
    &.van-field-code {
      padding: 0;
      position: relative;
      .van-field__body {
        padding: 10px 110px 10px 16px;
      }
      .van-field__button {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 0;
        width: 100px;
        color: #fff;
        background: #4e7eef;
        .van-count-down {
          color: #fff;
        }
      }
    }
  }
}

.button-wrap {
  margin: 20px;
  /deep/.van-button--primary {
    background: linear-gradient(
      0deg,
      rgba(75, 129, 239, 1) 0%,
      rgba(113, 71, 225, 1) 100%
    );
    border-radius: 4px 3px 3px 3px;
  }
}
</style>
